import { useSearchParams } from "react-router";

import { useSearchDisclosure } from "@nens/react/hooks";

export function useRanaSearchDisclosure(key: string) {
  const [searchParams, setSearchParams] = useSearchParams();
  return useSearchDisclosure(key, { searchParams, setSearchParams });
}
